import React from 'react';

// Components
import {Icon} from '@drivesally/sally-ui';
import Container from './components/Container';

const ModalLoader = () => (
  <Container>
    <Icon icon="loading2" spin />
  </Container>
);

export default ModalLoader;
